import TaxonomyTerm from "../../types/TaxonomyTerm";
import { TaxonomyAction, TaxonomyState } from "./TaxonomyState";

export const DISPATCH = 'WIS/taxonomy/country/DISPATCHED';
export const FULFILL = 'WIS/taxonomy/country/FULFILLED';
export const REJECT = 'WIS/taxonomy/country/REJECTED';

export type CountryActionTypes = 
  'WIS/taxonomy/country/DISPATCHED'
  | 'WIS/taxonomy/country/FULFILLED'
  | 'WIS/taxonomy/country/REJECTED';

export const dispatch = () => ({ type: DISPATCH });
export const fulfill = (payload: TaxonomyTerm[]) => ({ type: FULFILL, payload });
export const reject = (error: string) => ({ type: REJECT, error });

const initialState: TaxonomyState = {
  terms: [],
  isFetching: false,
  isFetched: false,
  error: null,
};

export type TaxonomyCountryAction = TaxonomyAction<CountryActionTypes>;

export default function reducer(state = initialState, action: TaxonomyCountryAction) {
  switch (action.type) {
    case DISPATCH:
      return {
        ...state,
        isFetching: true,
      };

    case FULFILL:
      return {
        ...state,
        terms: action.payload,
        isFetching: false,
        isFetched: true,
        error: null,
      };

    case REJECT:
      return {
        ...state,
        error: action.error,
        isFetching: false,
      };

    default:
      return state;
  }
}
